import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Stack, mergeStyles } from '@bingads-webui-react/fabric-control';
import classNames from 'classnames';
import { RedemptionStep } from '../components';
import { DaysRemaining } from './days-remaining';
import { getDaysToExpiration } from '../utils';

const redemptionStepsStyles = mergeStyles({
  marginTop: 16,
  marginBottom: 36,
});

const couponTermsStyles = mergeStyles({
  marginBottom: 36,
});

export const CouponDescription = ({ coupon, i18n, steps }) => {
  const daysToExpiration = useMemo(() => getDaysToExpiration(coupon.expirationDate), [coupon.expirationDate]);
  const displayDaysLeft = useMemo(() => daysToExpiration <= 14, [daysToExpiration]);

  return (
    <>
      <Stack horizontal horizontalAlign="space-between" className={redemptionStepsStyles}>
        {steps.map(step => (
          <RedemptionStep key={step.stepIndex} stepNumber={step.stepIndex} icon={step.icon} description={step.description} i18n={i18n} />
        ))}
      </Stack>
      <div className={classNames('coupon-terms', couponTermsStyles)}>
        <span>{i18n.getString('Coupon_Lightbox_LimitedTimeOffer_ActBy', coupon)}</span>
        {' '}
        {displayDaysLeft && <DaysRemaining i18n={i18n} diffDays={daysToExpiration} />}
      </div>
    </>
  );
};

CouponDescription.propTypes = {
  coupon: PropTypes.shape({
    expirationDate: PropTypes.string,
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  steps: PropTypes.arrayOf(PropTypes.shape({
    stepIndex: PropTypes.number,
    icon: PropTypes.string,
    description: PropTypes.string,
  })).isRequired,
};
